/* eslint-disable */
/** Date: 4/16/2021*/
/*PHD Pro Volunteer Search Form*/
export default {
    inserted: function (el) {
        var regionInput1 = document.getElementById('ahaRegionSelected'); // dropdown 1
        var regionInput2 = document.getElementById('domesticRegionSelected'); // dropdown 2
        var regionInput3 = document.getElementById('internationalRegionSelected'); // dropdown 3

        regionInput1.style.display = "block";
        regionInput2.style.display = "none";
        regionInput3.style.display = "none";

        document.addEventListener('click', function (event) {
            if (event.target.matches('input[name="region"]')) {
                var region = document.getElementsByName('region');

                var i;
                for (i = 0; i < region.length; i++) {
                    if (region[i].checked) {
                        if (region[i].value == 1) {
                            console.log("AHA Region")
                            regionInput1.style.display = "block";
                            regionInput2.style.display = "none";
                            regionInput3.style.display = "none";
                            break;
                        }
                        if (region[i].value == 2) {
                            console.log("Domestic")
                            regionInput1.style.display = "none";
                            regionInput2.style.display = "block";
                            regionInput3.style.display = "none";
                            break;
                        }
                        if (region[i].value == 3) {
                            console.log("International")
                            regionInput1.style.display = "none";
                            regionInput2.style.display = "none";
                            regionInput3.style.display = "block";
                            break;
                        }
                        region[i].addEventListener('click', function (event) {
                            console.log('clicked');
                        }, false);

                    }
                }
            }
        }, false);
    }
};


// WEBPACK FOOTER //
// ./src/app/directives/phd-pro-vol-search.js